export default __webpack_public_path__ + "static/media/CPASAGE_Client home page icons-05.31c4616a.svg";